var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from "react";
import styled, { ThemeProvider } from "styled-components";
import { HeaderBar } from "./components/HeaderBar";
import { ProxyRenderer } from "./components/ProxyRenderer";
import { DocViewerProvider } from "./store/DocViewerProvider";
import { defaultTheme } from "./defaultTheme";
import { DocViewerRenderers } from "./plugins";
var DocViewer = function (props) {
    var documents = props.documents, theme = props.theme;
    if (!documents) {
        throw new Error("Please provide an array of documents to DocViewer!");
    }
    return (React.createElement(DocViewerProvider, __assign({ pluginRenderers: DocViewerRenderers }, props),
        React.createElement(ThemeProvider, { theme: theme ? __assign(__assign({}, defaultTheme), theme) : defaultTheme },
            React.createElement(Container, __assign({ id: "react-doc-viewer", "data-testid": "react-doc-viewer" }, props),
                React.createElement(HeaderBar, null),
                React.createElement(ProxyRenderer, null)))));
};
export default memo(DocViewer);
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n  width: 100%;\n  height: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n  width: 100%;\n  height: 100%;\n"])));
export { DocViewerRenderers } from "./plugins";
export * from "./models";
export * from "./utils/fileLoaders";
export * from "./plugins";
var templateObject_1;
